const featureStyles = (theme) => ({
  title: {},
  icon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
});

export default featureStyles;
